import React,{useEffect} from 'react';
import './App.css';
import AppRouter from "./route/index";
import { SnackbarProvider } from "notistack";
import { ThemeProvider } from 'components/common/ThemeContext'


function App() {

  return (
    <ThemeProvider>
    <div className='bg-[#F7F6F9] dark:bg-[#000]  min-h-screen'>
      <SnackbarProvider maxSnack={1}>
        <AppRouter />
      </SnackbarProvider>
    </div>
    </ThemeProvider>
  );
}

export default App;
